import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.531 7.28-12 12a.75.75 0 0 1-1.061 0l-5.25-5.25a.75.75 0 1 1 1.061-1.06l4.72 4.72L20.47 6.22a.75.75 0 1 1 1.061 1.06"
    }, null, -1)
  ])))
}
export default { render: render }